<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><b><a id="page_iii"></a>Thank You!</b></h2>
<p class="center1"><span>The Bathroom Readers’ Institute thanks the following people whose advice and assistance made this book possible:</span></p>
<p class="center1"><span>Gordon Javna</span></p>
<p class="center"><span>JoAnn Padgett</span></p>
<p class="center"><span>Melinda Allman</span></p>
<p class="center"><span>Amy Miller</span></p>
<p class="center"><span>Jay Newman</span></p>
<p class="center"><span>Michael Brunsfeld</span></p>
<p class="center"><span>Jeff Altemus</span></p>
<p class="center"><span>Angie Kern</span></p>
<p class="center"><span>J. Carroll</span></p>
<p class="center"><span>Dan Mansfield</span></p>
<p class="center"><span>Chris Stuart</span></p>
<p class="center"><span>Scot A. McKibbin</span></p>
<p class="center"><span>Maggie McLaughlin</span></p>
<p class="center"><span>Stephanie Spadaccini</span></p>
<p class="center"><span>John Dollison</span></p>
<p class="center"><span>Sydney Stanley</span></p>
<p class="center"><span>David Cully</span></p>
<p class="center"><span>Monica Maestas</span></p>
<p class="center"><span>Amy L. and Lisa M.</span></p>
<p class="center"><span>Ginger Winters</span></p>
<p class="center"><span>Jennifer Frederick</span></p>
<p class="center"><span>Brian, Thom, and Julia</span></p>
<p class="center"><span>David Calder</span></p>
<p class="center"><span>Karen Malchow</span></p>
<p class="center"><span>Sophie, J.J., and Bea</span></p>
<p class="center"><span>Porter the Wonderdog</span></p>
<p class="centerx"><span><b>Uncle John’s Bathroom Reader Wise Up!</b> is a compilation of running feet and selected articles from the following previously published Bathroom Reader titles: <i>Uncle John’s Bathroom Reader Golden Plunger Awards © 2008, Uncle John’s Bathroom Reader Plunges Into Great Lives © 2003, Uncle John’s Bathroom Reader Plunges Into History © 2001, Uncle John’s Bathroom Reader Plunges Into History Again © 2004, Uncle John’s Bathroom Reader Plunges Into Hollywood © 2005, Uncle John’s Bathroom Reader Plunges Into Music © 2007, Uncle John’s Bathroom Reader Plunges Into National Parks © 2007, Uncle John’s Bathroom Reader Plunges Into the Presidency © 2004, Uncle John’s Bathroom Reader Plunges Into Texas © 2004, Uncle John’s Bathroom Reader Takes a Swing at Baseball © 2008, Uncle John’s Bathroom Reader Tees Off on Golf © 2005, Uncle John’s Bathroom Reader Wonderful World of Odd © 2006, Uncle John’s Curiously Compelling Bathroom Reader © 2006, Uncle John’s Fast-Acting Long-Lasting Bathroom Reader © 2005, Uncle John’s Great Big Bathroom Reader © 1998, Uncle John’s Slightly Irregular Bathroom Reader © 2004, Uncle John’s Triumphant 20th Bathroom Reader © 2007.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thank.vue?989fd31a